import { render, staticRenderFns } from "./SettingPlanDetailQ.vue?vue&type=template&id=3cfec880&scoped=true&"
import script from "./SettingPlanDetailQ.vue?vue&type=script&lang=js&"
export * from "./SettingPlanDetailQ.vue?vue&type=script&lang=js&"
import style0 from "./SettingPlanDetailQ.vue?vue&type=style&index=0&id=3cfec880&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfec880",
  null
  
)

export default component.exports